import { render, staticRenderFns } from "./taskToDelegate.vue?vue&type=template&id=0f2e117c&scoped=true&"
import script from "./taskToDelegate.vue?vue&type=script&lang=js&"
export * from "./taskToDelegate.vue?vue&type=script&lang=js&"
import style0 from "./taskToDelegate.vue?vue&type=style&index=0&id=0f2e117c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2e117c",
  null
  
)

export default component.exports